export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_-ElasticSearch-067a32844fd522349c542379d6c1f6dc.jpg";